import { useCrmTrueLocationFieldAndSearchEnabled } from "@/react/components/shared/MemberFilters/useCrmLocationEnabled";
import { useIsActivityScoreEnabledOrUpgradable } from "@circle-react/hooks/useIsActivityScoreEnabled";
import {
  accessGroupsFilter,
  activityScoreFilter,
  bioFilter,
  emailFilter,
  eventsFilter,
  geoLocationFilter,
  hasPastDueSubscriptionFilter,
  headlineFilter,
  invitationLinkIdsFilter,
  invitedAtDaysAgoFilter,
  isAvatarSetFilter,
  joinedCommunityDaysAgoFilter,
  lastLoggedInDaysAgoFilter,
  levelFilter,
  locationFilter,
  nameFilter,
  onlineStatusFilter,
  paywallsFilter,
  segmentFilter,
  spaceGroupsFilter,
  spacesFilter,
  subscribedToMarketingEmailsFilter,
  tagsFilter,
} from "./filterConfiguration";

export const memberTabFilters = [
  segmentFilter,
  nameFilter,
  emailFilter,
  subscribedToMarketingEmailsFilter,
  invitedAtDaysAgoFilter,
  invitationLinkIdsFilter,
  tagsFilter,
  spacesFilter,
  spaceGroupsFilter,
  onlineStatusFilter,
  bioFilter,
  headlineFilter,
  locationFilter,
  geoLocationFilter,
  paywallsFilter,
  eventsFilter,
  hasPastDueSubscriptionFilter,
  joinedCommunityDaysAgoFilter,
  lastLoggedInDaysAgoFilter,
  isAvatarSetFilter,
  activityScoreFilter,
  levelFilter,
  accessGroupsFilter,
];

export const useDefaultMemberFilters = () => {
  const isMemberActivityScoreEnabledOrUpgradable =
    useIsActivityScoreEnabledOrUpgradable();

  const isCrmTrueLocationFieldAndSearchEnabled =
    useCrmTrueLocationFieldAndSearchEnabled();

  const defaultFilterItems = [
    nameFilter.name,
    spacesFilter.name,
    tagsFilter.name,
    eventsFilter.name,
    subscribedToMarketingEmailsFilter.name,
    segmentFilter.name,
  ];

  if (isCrmTrueLocationFieldAndSearchEnabled) {
    defaultFilterItems.push(geoLocationFilter.name);
  }

  if (isMemberActivityScoreEnabledOrUpgradable) {
    return [...defaultFilterItems, activityScoreFilter.name];
  }

  return defaultFilterItems;
};
